import React, { useEffect, useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Box, withStyles } from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'
import animationData from 'src/lotties/mcg-loader-robo-png.json'
import Lottie from 'react-lottie'
import styles from './styles'

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
})

function LinearDeterminate({ progress }) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <LinearProgress variant="determinate" value={progress} />
    </div>
  )
}

const AiLoading = props => {
  const {
    progress: initialProgress = 0,
    responseReceived = false,
    classes,
  } = props
  const [progress, setProgress] = useState(initialProgress)
  // Removed the increasing state since we're always increasing
  const timerRef = useRef(null)
  const startTimeRef = useRef(Date.now())
  const fourMinutesInMs = 4 * 60 * 1000
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  // Progressive loader that takes 4 minutes to reach 80% from the beginning
  useEffect(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
    }

    // If response received, set to 100% and exit
    if (responseReceived) {
      setProgress(100)
      return
    }

    // Always start from a low value when component mounts (unless initialProgress is higher)
    if (progress < 5 && initialProgress < 5) {
      setProgress(5) // Start at 5% for better initial visual feedback
    }

    // Calculate pace to reach 80% in 4 minutes
    const totalRange = 75 // From 5% to 80%
    const totalTimeMs = 4 * 60 * 1000 // 4 minutes in milliseconds
    const updateIntervalMs = 1000 // Update every 1 second
    const totalUpdates = totalTimeMs / updateIntervalMs
    const incrementPerUpdate = totalRange / totalUpdates

    timerRef.current = setInterval(() => {
      // Handle response received case
      if (responseReceived) {
        setProgress(100)
        clearInterval(timerRef.current)
        return
      }

      setProgress(prevProgress => {
        // If we reach 80%, reset to beginning
        if (prevProgress >= 80) {
          return 5
        }

        // Increment with calculated pace to reach 80% in 4 minutes
        return Math.min(prevProgress + incrementPerUpdate, 80)
      })
    }, updateIntervalMs)

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    }
  }, [responseReceived])

  return (
    <div className={classes.container}>
      <div className={classes.box}>
        <Lottie options={defaultOptions} height={120} width={120} />

        <LinearDeterminate progress={progress}></LinearDeterminate>

        <Typography className={classes.header}>
          Generating Your Interactive Activity Block with AI
        </Typography>
        <Typography className={classes.title}>
          This process may take a few minutes. Please do not close the popup or
          refresh the page. Thank you for your patience...
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(AiLoading)
